import { axiosGet } from '@/API/API';
import { fetchUser, setIsAuthenticatedUser, setIsFetching, setIsLogin } from '@/store/authenticatedUserSlice';
import { RootState } from '@/store/store';

import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { registerLocale } from '@sobrus-com/sobrus-design-system-v2';
import { fr } from 'date-fns/locale';

import HomeNavigation from './HomeNavigation';

const MainNavigator = () => {
	const user = useSelector((state: RootState) => state.user);
	const dispatch = useDispatch();

	useLayoutEffect(() => {
		if (!user.isLogin && user.isFetching && user.isAuthenticatedUser) {
			axiosGet<any>('authenticatedUser').then((res) => {
				if (res?.data) {
					dispatch(setIsLogin(true));
					dispatch(fetchUser(res?.data));
				} else {
					localStorage.setItem('isAuthenticatedUser', 'false');
					dispatch(setIsAuthenticatedUser(false));
				}

				dispatch(setIsFetching(false));
			});
		}
		registerLocale('fr', fr);
	}, [user.isLogin, user.isFetching, user.isAuthenticatedUser]);

	return (
		<BrowserRouter>
			<HomeNavigation />
		</BrowserRouter>
	);
};

export default MainNavigator;
